export type CsvValue = string | number | boolean | null | undefined;
export type CsvRow = CsvValue[];

const escapeCsvValue = (value: CsvValue) => {
    const stringValue = value === null || value === undefined ? '' : String(value);

    if (/[",\r\n]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
};

export const downloadCsv = (filename: string, rows: CsvRow[]) => {
    const csv = rows.map(row => row.map(escapeCsvValue).join(',')).join('\r\n');
    const url = window.URL.createObjectURL(new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' }));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
